import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { Link } from "react-router-dom";

const OrderDetails = ({ dashboardData , shipOrderStatus }) => {

    console.log("Order Details", shipOrderStatus)
    return (
      <div className="col-xxl-6">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
              <h6 className="mb-2 fw-bold text-lg">Order Details</h6>
              <Link
                to={"/order-management"}
                className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
              >
                Manage
                <Icon icon="solar:alt-arrow-right-linear" className="icon" />
              </Link>
            </div>

            <div className="mt-32">
              {/* Review Orders */}
              <div className="d-flex align-items-center justify-content-between gap-3 mb-24">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center  flex-shrink-0 text-primary-600 bg-primary-light ">
                    <Icon
                      icon="mdi:clipboard-search-outline"
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[0]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[0]?.value}
                </span>
              </div>
              {/* Placed Orders */}
              <div className="d-flex align-items-center justify-content-between gap-3 mb-24">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center  flex-shrink-0 text-primary-600 bg-primary-light ">
                    <Icon
                      icon="mdi:cart-plus"
                      className=""
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[1]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[1]?.value}
                </span>
              </div>

              {/* Received Orders */}
              <div className="d-flex align-items-center justify-content-between gap-3 mb-24">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center 	bg-cyan-100 flex-shrink-0">
                    <Icon
                      icon="mdi:inbox-arrow-down"
                      className="text-cyan-700"
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[2]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[2]?.value}
                </span>
              </div>

              {/* Shipped Orders */}
              <div className="d-flex align-items-center justify-content-between gap-3 mb-24">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center text-yellow bg-yellow-light flex-shrink-0">
                    <Icon
                      icon="mdi:truck-fast"
                      className=""
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[3]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[3]?.value}
                </span>
              </div>

              {/* Reached to local partner */}
              <div className="d-flex align-items-center justify-content-between gap-3 mb-24">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center text-pink bg-pink-light flex-shrink-0">
                    <Icon
                      icon="mdi:map-marker-path"
                      className=""
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[4]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[4]?.value}
                </span>
              </div>

              {/* Delivered Orders */}
              <div className="d-flex align-items-center justify-content-between gap-3 mb-24">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center bg-success-100 flex-shrink-0">
                    <Icon
                      icon="mdi:package-variant-closed"
                      className="text-success"
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[5]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[5]?.value}
                </span>
              </div>
              {/* Refunded Orders */}
              <div className="d-flex align-items-center justify-content-between gap-3 mb-24">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center bg-success-100 flex-shrink-0">
                    <Icon
                      icon="mdi:restore"
                      className="text-warning"
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[6]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[6]?.value}
                </span>
              </div>

              <div className="d-flex align-items-center justify-content-between gap-3 mb-24">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center bg-danger-100 flex-shrink-0">
                    <Icon
                      icon="mdi:close-circle-outline"
                      className="text-danger"
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[7]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[7]?.value}
                </span>
              </div>

              {/* Hold Orders */}
              <div className="d-flex align-items-center justify-content-between gap-3 mb-0">
                <div className="d-flex align-items-center gap-3">
                  <div className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center bg-warning-100 flex-shrink-0">
                    <Icon
                      icon="mdi:pause-circle-outline"
                      className="text-warning"
                      width="24"
                      height="24"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-medium">
                      {shipOrderStatus?.[8]?.title}
                    </h6>
                  </div>
                </div>
                <span className="text-secondary-light text-md fw-bold">
                  {shipOrderStatus?.[8]?.value}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default OrderDetails;
